import { render, staticRenderFns } from "./AlertHeading.vue?vue&type=template&id=8e4802cc&"
import script from "./AlertHeading.vue?vue&type=script&lang=js&"
export * from "./AlertHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports